import React, { useState, useEffect } from 'react';
import InnovaTechCard from '../components/InnovaTechCard';
import AIResponseCard from '../components/AIResponseCard';
import { mockSessionAdvance } from '../services/innovatechMockAPI';

// 🎯 Página InnovaTech Lab1 - LIMPIA y ENFOCADA
const InnovaTechLab1 = () => {
    const [aiResponse, setAiResponse] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    // 🔖 Registrar acceso rápido cuando el usuario entra a esta página
    useEffect(() => {
        const quickAccess = {
            id: 'innovatech-lab1-clean',
            title: 'Lab1 - Hipótesis',
            path: '/innovatech-lab1-clean',
            icon: 'Lightbulb',
            timestamp: Date.now()
        };
        
        // Guardar en localStorage para que aparezca en sidebar
        const existingAccess = JSON.parse(localStorage.getItem('quickAccess') || '[]');
        const filteredAccess = existingAccess.filter(item => item.id !== quickAccess.id);
        const newAccess = [quickAccess, ...filteredAccess].slice(0, 5); // Max 5 accesos rápidos
        
        localStorage.setItem('quickAccess', JSON.stringify(newAccess));
        
        console.log('🔖 [Acceso Rápido] Registrado:', quickAccess.title);
    }, []);

    const handleSubmitHypothesis = async (hypothesis) => {
        setIsProcessing(true);
        setAiResponse(null);
        
        try {
            // 🧠 Contexto específico para Lab1 - El dispatcher asignará rol "tutor"
            const context = {
                lab_id: "lab1",
                step_id: "hipotesis", 
                user_input: hypothesis,
                session_id: `session_${Date.now()}`
            };

            console.log('🎯 [InnovaTech Lab1] Enviando hipótesis:', hypothesis);
            console.log('📋 [InnovaTech Lab1] Contexto:', context);

            // 🚀 Llamada al sistema IA
            const result = await mockSessionAdvance({
                ...testContext,
                session_id: `session_${Date.now()}`
            });
            
            console.log('✅ [InnovaTech Lab1] Respuesta recibida:', result);

            // 🎭 Mostrar respuesta
            setAiResponse({
                content: result.content || result.mensaje || "Respuesta procesada correctamente",
                role: result.ai_role || "tutor",
                source: result.ai_source || "fallback"
            });

        } catch (error) {
            console.error('❌ [InnovaTech Lab1] Error:', error);
            
            // 🛡️ Fallback amigable
            setAiResponse({
                content: "Hubo un problema procesando tu hipótesis. Por favor, intenta nuevamente o verifica tu conexión.",
                role: "tutor",
                source: "error"
            });
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-indigo-50 py-8">
            <div className="container mx-auto px-4">
                {/* 📋 Formulario Principal */}
                <InnovaTechCard
                    title="Formulario de Hipótesis InnovaTech"
                    description="Desarrolla tu hipótesis de innovación con el apoyo de nuestro Coach IA especializado"
                    onSubmit={handleSubmitHypothesis}
                    isProcessing={isProcessing}
                    placeholder="Ejemplo: Creemos que estudiantes universitarios de ingeniería tienen dificultades para encontrar prácticas profesionales relevantes porque las plataformas actuales no filtran por especialización técnica."
                />

                {/* 🤖 Respuesta IA */}
                {isProcessing && (
                    <AIResponseCard
                        aiRole="tutor"
                        aiSource="openai"
                        isLoading={true}
                    />
                )}

                {/* ✅ Resultado Final */}
                {aiResponse && !isProcessing && (
                    <AIResponseCard
                        response={aiResponse.content}
                        aiRole={aiResponse.role}
                        aiSource={aiResponse.source}
                    />
                )}

                {/* 📚 Guía de ayuda */}
                {!aiResponse && !isProcessing && (
                    <div className="max-w-4xl mx-auto mt-8 p-4 bg-white/70 rounded-lg border border-gray-200">
                        <h4 className="font-semibold text-gray-800 mb-2">💡 Consejos para una buena hipótesis:</h4>
                        <ul className="text-sm text-gray-600 space-y-1">
                            <li>• <strong>Específico:</strong> Define claramente el grupo de usuarios</li>
                            <li>• <strong>Observable:</strong> Describe un problema que puedas validar</li>
                            <li>• <strong>Accionable:</strong> Explica una razón que puedas investigar</li>
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InnovaTechLab1;